import React, { useEffect, useState } from 'react'
import './AdminRequests.scss'
import { requestService } from '../../services/requestService'
import { PaginationList } from '../../components'
import { IoCheckboxOutline } from 'react-icons/io5'
import { toast } from 'react-toastify'

export default function AdminRequests() {
  const [page, setPage] = useState(1)
  const [requests, setRequests] = useState([])
  const [totalPages, setTotalPages] = useState(1)

  const handlePageChange = newPage => {
    setPage(newPage)
    window.scrollTo({ top: 100, behavior: 'smooth' })
  }

  const openUserProfile = (e, userId) => {
    e.preventDefault()
    window.open(`/korisnik/${userId}`, '_blank', 'noopener,noreferrer')
  }

  const markRequestAsCompleted = async requestId => {
    const response = await requestService.markAsCompleted({ requestId })
    if (response.isOk) {
      toast.success('Zahtjev obrađen.')
      setRequests(prevRequests => {
        return prevRequests.filter(r => r.id !== requestId)
      })
    } else {
      toast.error(response?.message)
    }
  }

  useEffect(() => {
    const fetchRequests = async () => {
      const response = await requestService.getRequests({ page })
      if (response.isOk && response.data) {
        setTotalPages(response.data.last_page)
        setRequests(response.data.data)
      }
    }

    fetchRequests()
  }, [page])

  return (
    <div className="admin-requests">
      <h1 className="page-title">{`Zahtjevi`}</h1>

      {requests.map(request => {
        const senderName = `${request.sender.first_name} ${request.sender.last_name}`

        return (
          <div className="request-row">
            <a
              key={request.id}
              href={`/admin/admin-zahtjev/${request.id}`}
              target="_blank">
              <span
                onClick={e => openUserProfile(e, request.sender.id)}
                className="item sender">{`${request.id}. ${senderName}`}</span>
              <span className="item">{request.location}</span>
              <span className="item title">{request.title}</span>

              <div
                className="check-icon"
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  markRequestAsCompleted(request.id)
                }}>
                <IoCheckboxOutline />
              </div>
            </a>
          </div>
        )
      })}

      <PaginationList
        currentPage={page}
        handlePageChange={handlePageChange}
        totalPages={totalPages}
      />
    </div>
  )
}
